/*
* @描述: 菜单管理页面
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2022-11-23 17:37:04
*/
<template>
    <div class="page_container" v-loading="loading">
        <el-form size="small"
                 @submit.native.prevent
                 :inline="true">
            <div class="flex_js_wrap">
                <div>
                    <el-form-item>
                        <el-input placeholder="请输入链接" v-model="route"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleClickSearch">搜索</el-button>
                        <el-button @click="handleClickReset">重置</el-button>
                    </el-form-item>
                </div>
                <el-form-item>
                    <el-button type="primary" @click="handleClickUnfold">
                        {{ expandAll ? '全部收起' : '全部展开' }}
                    </el-button>
                    <el-button type="primary" @click="handleClickAddMenu">新增菜单</el-button>
                </el-form-item>
            </div>
        </el-form>
        <el-table :data="navList"
                  border
                  :height="tableHeight"
                  ref="dataTable"
                  row-key="id"
                  default-expand-all
                  :default-expand-all="expandAll"
                  :tree-props="{children: '_child', hasChildren: 'hasChildren'}">
            <el-table-column label="排序" width="100" type="">
                <template slot-scope="{row}">
                    <span v-if="row.pid!==0">└─── </span>
                    <span v-text="row.sort"></span>
                </template>
            </el-table-column>
            <el-table-column label="菜单名称" prop="title" align="" min-width="195">
                <template slot-scope="{row}">
                    <span :class="{'theme_color':!row._child,'padding_left':row.pid === 0 && !row._child}"
                          @click="handleClickPoint(row)">
                        <span v-if="row.pid!==0">└─── </span>
                        <span v-text="row.title"></span>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="图标" prop="ico" align="center" width="150" type="">
                <template slot-scope="{row}">
                    <i class="iconfont" :class="row.ico"></i>
                </template>
            </el-table-column>
            <el-table-column label="链接" prop="route" align="" min-width="260" type=""></el-table-column>
            <el-table-column label="角色权限是否展示" width="150" align="center">
                <tempalte slot-scope="{row}">
                    <el-switch v-model="row.role_show"
                               active-text=""
                               inactive-text=""
                               :active-value="1"
                               :inactive-value="0"
                               @change="handleTreeNodeEdit($event,row)">
                    </el-switch>
                </tempalte>
            </el-table-column>
            <el-table-column label="是否有范围数据权限" width="150" align="center">
                <tempalte slot-scope="{row}">
                    <el-switch v-model="row.role_range"
                               active-text=""
                               inactive-text=""
                               :active-value="1"
                               :inactive-value="0"
                               @change="handleTreeNodeEdit($event,row)">
                    </el-switch>
                </tempalte>
            </el-table-column>
            <el-table-column label="是否为公共节点" width="150" align="center">
                <tempalte slot-scope="{row}">
                    <el-switch v-model="row.is_public"
                               active-text=""
                               inactive-text=""
                               :active-value="1"
                               :inactive-value="0"
                               @change="handleTreeNodeEdit($event,row)">
                    </el-switch>
                </tempalte>
            </el-table-column>
<!--          <el-table-column label="租户菜单权限" width="150" align="center">-->
<!--            <tempalte slot-scope="{row}">-->
<!--              <el-switch v-model="row.is_public"-->
<!--                         active-text=""-->
<!--                         inactive-text=""-->
<!--                         :active-value="1"-->
<!--                         :inactive-value="0"-->
<!--                         @change="handleTreeNodeEdit($event,row)">-->
<!--              </el-switch>-->
<!--            </tempalte>-->
<!--          </el-table-column>-->
            <el-table-column label="操作" align="right" width="180" type="">
                <template slot-scope="{row}">
                    <el-button v-if="row.pid ===0" type="text" @click="handleClickAddChildMenu(row)">
                        新增子菜单
                    </el-button>
                    <el-button type="text" @click="handleClickEditMenu(row.id)">编辑</el-button>
                    <el-button type="text" @click="handleClickDelMenu(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <AddMenu v-if="addVisible"
                 :addVisible.sync="addVisible"
                 :addTitle="addTitle"
                 :menuPid="menuPid"
                 :pid_path="menu_pid_path"
                 @success="getAllMenuList"/>
        <EditMenu v-if="editVisible" :editVisible.sync="editVisible" :menuId="menuId" @success="getAllMenuList"/>
        <Point v-if="pointVisible" :pointVisible.sync="pointVisible" :menuId="menuId" :menu_pid_path="menu_pid_path"/>
    </div>
</template>
<script>
    import {DelMenu, ReqMenuList, treeNodeEdit} from '@/api'
    import {getTableStateHeight} from '@/utils'
    import AddMenu from './addMenu'
    import EditMenu from './editMenu'
    import Point from './point.vue'

    export default {
        name: 'navList',
        data() {
            return {
                navList: [], //菜单列表
                addVisible: false,//新增菜单对话框显示/隐藏
                editVisible: false,//编辑菜单对话框显示/隐藏
                route: '', //搜索关键字
                tableHeight: undefined,//table高度
                loading: false,//加载动画
                resizeTimer: null, //节流定时器
                menuId: 0,//菜单id
                addTitle: '新增菜单',
                menuPid: 0,
                pointVisible: false, //功能点弹窗
                expandAll: true,
                menu_pid_path: ''
            }
        },
        components: {
            AddMenu,
            EditMenu,
            Point,
        },
        mounted() {
            this.tableHeight = this.tableHeight = getTableStateHeight('page_container', 'el-form', 20)
            this.getMenuList()
            //窗口缩放时动态修改table的高度
            window.onresize = () => {
                if (this.resizeTimer) {
                    clearTimeout(this.resizeTimer)
                }
                //开启定时器，节流函数
                this.resizeTimer = setTimeout(() => {
                    //将计算的table高度赋值给table
                    this.tableHeight = this.tableHeight = getTableStateHeight('page_container', 'el-form', 20)
                    //清除定时器
                    this.resizeTimer = null
                }, 100)
            }
        },
        methods: {
            //请求菜单列表
            getMenuList() {
                this.loading = true
                ReqMenuList({
                    route: this.route,
                }).then(res => {
                    if (res.code === 200) {
                        this.navList = res.data
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            },

            handleClickUnfold() {
                this.expandAll = !this.expandAll
                this.navList.forEach(item => {
                    this.$refs.dataTable.toggleRowExpansion(item, this.expandAll)
                })
            },

            //列表搜索
            handleClickSearch() {
                this.getMenuList()
            },

            //重置列表
            handleClickReset() {
                this.route = ''
                this.getMenuList()
            },

            //点击新增菜单
            handleClickAddMenu() {
                this.addTitle = '新增菜单'
                this.addVisible = true
            },

            //点击新增子菜单
            handleClickAddChildMenu(row) {
                this.addTitle = '新增子菜单'
                this.menuPid = row.id
                if (row.pid === 0) {
                    this.menu_pid_path = row.id + ''
                } else {
                    this.menu_pid_path = row.pid_path + row.id
                }
                this.addVisible = true
            },

            //点击修改菜单
            handleClickEditMenu(id) {
                this.menuId = id
                this.editVisible = true
            },

            //点击删除菜单
            handleClickDelMenu(row) {
                if (row._child) {
                    this.$message.error('请先删除子菜单')
                    return false
                }
                this.$confirm('确定删除菜单吗', '提示', {
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    type: 'error'
                }).then(() => {
                    DelMenu({
                        treenode_id: row.id
                    }).then(() => {
                        this.$message.success('删除成功')
                        this.getAllMenuList()
                    })
                }).catch(() => {
                    return false
                })
            },

            //节点状态编辑
            handleTreeNodeEdit(val, row) {
                treeNodeEdit({
                    treenode_id: row.id,
                    role_show: row.role_show,
                    role_range: row.role_range,
                    is_public: row.is_public,
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('设置成功')
                    }
                })
            },

            // 查看功能点
            handleClickPoint(row) {
                this.menuId = row.id
                this.menu_pid_path = row.pid_path + row.id
                this.pointVisible = true
            },

            getAllMenuList() {
                this.getMenuList()
            },
        },
    }
</script>
<style lang="scss" scoped>
  .padding_left {
    padding-left: 22px;
    box-sizing: border-box;
  }
</style>
